export default __webpack_public_path__ + "static/media/plus-blue.f6527ca2.svg";